import React, { useEffect, useRef, useState } from "react";
import { message, Modal } from "antd";
import { useSelector } from "react-redux";
import { RupeesIcon } from "../Header/AccountModalSvg";
import "./AddMoneyModal.css";
import { apiClient } from "../../config/api.client";

const AddMoneyModal = ({ showAddMoneyModal, setShowAddMoneyModal }) => {
	const { user } = useSelector((state) => state.user);
	const [amount, setAmount] = useState("");
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [orderId, setOrderId] = useState(null);
	const [gateway, setGateway] = useState("BARCODE");
	const [supportVisible, setSupportVisible] = useState(false);
	const [supportError, setSupportError] = useState("");

	// Create a ref for the input field
	const amountInputRef = useRef(null);

	const closeModal = (e) => {
		e.stopPropagation();
		setShowAddMoneyModal(false);
	};

	const handleOnChange = (e) => {
		setAmount(e.target.value);
		if (e.target.value !== "0" && e.target.value.trim() !== "") {
			setError(false);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const amountNumber = Number(amount);
		if (isNaN(amountNumber)) {
			return message.error("Please enter amount in number");
		}
		if (amount === "" || amount === "0") {
			return setError(true);
		} else {
			handleBarcode();
		}
	};

	const generateOrderId = () => {
		const now = new Date();
		const year = now.getFullYear().toString().slice(-2); // Last two digits of the year
		const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
		const day = now.getDate().toString().padStart(2, "0");
		const hours = now.getHours().toString().padStart(2, "0");
		const minutes = now.getMinutes().toString().padStart(2, "0");
		const seconds = now.getSeconds().toString().padStart(2, "0");
		const randomNum = Math.floor(1000 + Math.random() * 9000); // Ensures a 4-digit number
		const orderId = `${year}${month}${day}${hours}${minutes}${seconds}${randomNum}`;

		setOrderId(orderId);
	};

	useEffect(() => {
		generateOrderId();
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		amountInputRef.current.focus();
		// eslint-disable-next-line
	}, []);

	async function handleBarcode() {
		setLoading(true);
		try {
			const payload = {
				amount: Number(amount),
				redirectUrl: "https://coinsup.in/payment-status"
			};
			const response = await apiClient.post("/wallet/add", payload, {
				headers: { "Content-Type": "application/json" }
			});
			const data = response?.data || {};
			const redirect = data?.transaction?.paymentUrl;
			if (redirect) {
				window.location.href = redirect;
			} else if (data?.success) {
				message.success(data?.message || "Redirecting to payment...");
			} else {
				const apiError = data?.error || data?.message || "Unable to initiate payment";
				setSupportError(apiError);
				setSupportVisible(true);
				message.error("Unable to initiate transaction");
			}
		} catch (error) {
			console.error("Error initiating payment:", error);
			const apiError = error?.response?.data?.error || error?.message || "Failed to initiate payment";
			setSupportError(apiError);
			setSupportVisible(true);
			message.error("Unable to initiate transaction");
		} finally {
			setLoading(false);
		}
	}

	return (
		<>
			<div
				className={`add-money-container ${showAddMoneyModal ? "active" : ""}
				`}
				onClick={closeModal}
			>
				<div
					className={`add-money-content ${showAddMoneyModal ? "active" : ""} p-3`}
					onClick={(e) => e.stopPropagation()}
				>
					<div className="mt-2 py-1 w-100">
						<div className="d-flex justify-content-between align-items-center">
							<h1 className="mb-0">Add Money</h1>
							<button
								className="bg-none border-0 center p-2 rounded-pill"
								data-bs-dismiss="offcanvas"
								onClick={closeModal}
							>
								<svg
									width="25"
									height="25"
									fill="currentColor"
									className="bi bi-x"
									viewBox="0 0 16 16"
								>
									<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
								</svg>
							</button>
						</div>
						<form
							className="content mt-0 p-0 mt-3"
							autoComplete="off"
							onSubmit={handleSubmit}
						>
							<div className="form-custom">
								<div className="position-relative mb-2">
									<input
										type="number"
										autoComplete="off"
										name="amount"
										placeholder="Enter your amount"
										id="amount"
										className={`w-100 form-control ${error && "is-invalid"}`}
										value={amount}
										onChange={handleOnChange}
										ref={amountInputRef} // Attach ref to the input
									/>
									<div className="add-money-modal-rupees-icon">
										<RupeesIcon />
									</div>
								</div>
								{error && (
									<small className="text-danger">Please enter an amount</small>
								)}
							</div>
							<div className="pb-3"></div>
							{!loading ? (
								<button
									className="btn btn-full gradient-blue shadow-bg shadow-bg-s w-100"
									type="submit"
								>
									CONTINUE
									{/* Wallet is Temporarily Disabled */}
								</button>
							) : (
								<button
									disabled
									className="btn btn-full gradient-blue shadow-bg shadow-bg-s w-100"
								>
									<div className="spinner-border spinner-border-sm" role="status">
										<span className="visually-hidden"></span>
									</div>
								</button>
							)}
						</form>
					</div>
				</div>
			</div>
			<Modal
				open={supportVisible}
				onCancel={() => setSupportVisible(false)}
				footer={null}
				title="Add money not working --"
			>
				<p className="mb-2">
					{ "Gateway issue or merchant disconnected or limit crossed."}
				</p>
				<div className="d-flex gap-2">
					<a
						href={`https://t.me/CoinsUp01?text=${encodeURIComponent(
							"Add money not working - gateway issue"
						)}`}
						target="_blank"
						rel="noreferrer"
						className="btn btn-success"
					>
						Contact Support on Telegram
					</a>
					<a href="mailto:coinssups@gmail.com?subject=Add%20Money%20Issue&body=Add%20money%20not%20working%20-%20gateway%20issue%20or%20merchant%20disconnect%20or%20limit%20crossed" className="btn btn-outline-primary">
						Email Support
					</a>
				</div>
			</Modal>
		</>
	);
};

export default AddMoneyModal;
